import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App'

// ── Meta Pixel ──────────────────────────────────────────
;
(function () {
  const s = document.createElement('script');
  s.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init','951909027159376');
    fbq('track','PageView');
  `;
  document.head.appendChild(s);
  const ns = document.createElement('noscript');
  ns.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=951909027159376&ev=PageView&noscript=1"/>';
  document.head.appendChild(ns);
})();
// ────────────────────────────────────────────────────────

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-220" data-mp="15lkb6gdhbh06" />);
}